import React from "react";
import { Mute, OnMusic } from "../icons";
import classes from "./MuteButton.module.scss";

interface IMuteButtonProps {
  isMuted: boolean;
  onToggleMute: () => void;
}

const MuteButton: React.FC<IMuteButtonProps> = ({ isMuted, onToggleMute }) => {
  return (
    <div className={classes.container} onClick={onToggleMute}>
      {isMuted ? <Mute /> : <OnMusic />}
    </div>
  );
};

export default MuteButton;
